import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractServiceCatalogApiService } from '../abstract/abstract-service-catalog-api-service';
import { Observable } from 'rxjs';
import { InteractorResponse } from '../../models/interactor-response';
import { AppConstants } from '../../constants/app-constants';
import { ServiceCategoryModel, ServiceMasterCategoryModel, ServiceModel } from '../../../store/self-diagnostic/service-catalog/model';

const baseUrl = `/api/serviceCatalog`;

@Injectable()
export class ServiceCatalogApiService extends AbstractServiceCatalogApiService {
  private http = inject(HttpClient);

  public getAll(): Observable<InteractorResponse<ServiceModel[]>> {
    return this.http.get<InteractorResponse<ServiceModel[]>>(`${baseUrl}`);
  }

  public enable(codes: number[]): Observable<InteractorResponse<ServiceModel[]>> {
    return this.http.post<InteractorResponse<ServiceModel[]>>(`${baseUrl}/enable`, codes);
  }

  public disable(codes: number[]): Observable<InteractorResponse<ServiceModel[]>> {
    return this.http.post<InteractorResponse<ServiceModel[]>>(`${baseUrl}/disable`, codes);
  }

  public sync(): Observable<InteractorResponse<ServiceModel[]>> {
    return this.http.get<InteractorResponse<ServiceModel[]>>(`${baseUrl}/sync`);
  }

  public getByCode(code: number): Observable<InteractorResponse<ServiceModel>> {
    return this.http.get<InteractorResponse<ServiceModel>>(`${baseUrl}/by-code?code=${code}`);
  }

  public updateService(service: ServiceModel): Observable<InteractorResponse<ServiceModel>> {
    return this.http.post<InteractorResponse<ServiceModel>>(`${baseUrl}/updateService`, service);
  }

  public updateCategory(category: ServiceCategoryModel): Observable<InteractorResponse<ServiceCategoryModel>> {
    return this.http.post<InteractorResponse<ServiceCategoryModel>>(`${baseUrl}/updateCategory`, category);
  }

  public uploadCategoryIcon(category: ServiceCategoryModel, file: File): Observable<InteractorResponse<ServiceCategoryModel>> {
    let formData: FormData = new FormData();

    formData.append('jsonRequest', JSON.stringify(category));
    formData.append('file', file);

    return this.http.post<InteractorResponse<ServiceCategoryModel>>(`${baseUrl}/uploadCategoryIcon`, formData);
  }

  public deleteCategoryIcon(category: ServiceCategoryModel): Observable<InteractorResponse<ServiceCategoryModel>> {
    return this.http.post<InteractorResponse<ServiceCategoryModel>>(`${baseUrl}/deleteCategoryIcon`, category);
  }

  public uploadMasterCategoryIcon(
    masterCategory: ServiceMasterCategoryModel,
    file: File
  ): Observable<InteractorResponse<ServiceMasterCategoryModel>> {
    let formData: FormData = new FormData();

    formData.append('jsonRequest', JSON.stringify(masterCategory));
    formData.append('file', file);

    return this.http.post<InteractorResponse<ServiceMasterCategoryModel>>(`${baseUrl}/uploadMasterCategoryIcon`, formData);
  }

  public deleteMasterCategoryIcon(masterCategory: ServiceMasterCategoryModel): Observable<InteractorResponse<ServiceMasterCategoryModel>> {
    return this.http.post<InteractorResponse<ServiceMasterCategoryModel>>(`${baseUrl}/deleteMasterCategoryIcon`, masterCategory);
  }

  public upPriorityCategory(category: ServiceCategoryModel): Observable<InteractorResponse<ServiceCategoryModel>> {
    return this.http.post<InteractorResponse<ServiceCategoryModel>>(`${baseUrl}/upPriorityCategory`, category);
  }

  public downPriorityCategory(category: ServiceCategoryModel): Observable<InteractorResponse<ServiceCategoryModel>> {
    return this.http.post<InteractorResponse<ServiceCategoryModel>>(`${baseUrl}/downPriorityCategory`, category);
  }

  public upPriorityMasterCategory(masterCategory: ServiceMasterCategoryModel): Observable<InteractorResponse<ServiceMasterCategoryModel>> {
    return this.http.post<InteractorResponse<ServiceMasterCategoryModel>>(`${baseUrl}/upPriorityMasterCategory`, masterCategory);
  }

  public downPriorityMasterCategory(
    masterCategory: ServiceMasterCategoryModel
  ): Observable<InteractorResponse<ServiceMasterCategoryModel>> {
    return this.http.post<InteractorResponse<ServiceMasterCategoryModel>>(`${baseUrl}/downPriorityMasterCategory`, masterCategory);
  }
}
